<script lang="ts" setup>
import { showErrorMsg } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import icon from '@core/assets/image/im/icon-code.svg';
import { ZoneService } from '@core/services/zone.service';
import type { CodeVo } from '@core/types/auto/oj';
import { PAGE_BASE } from '@core/utils/environment';
import { EventService } from '../../event.service';
import { ImService } from '../../im.service';
import ActionBtn from './ActionBtn.vue';
import { CodeActionService } from './CodeAction.service';

const props = defineProps<{
  sendCode: (code: { title: string; url: string }) => void;
  disabled: boolean;
}>();
const codeActionService = useService(CodeActionService);
const zoneService = useService(ZoneService);
const eventService = useService(EventService);
const imService = useService(ImService);
const getUserCode = async () => {
  try {
    const res = (await eventService.getUserCode()) as {
      pid: number;
      code: string;
      title: string;
      tid: number | undefined;
      gid: number | undefined;
    };
    if (!res.code.trim()) {
      imService.messageApi.error('当前无代码可发送');
      return;
    }
    const { submitId, codeId } = (await codeActionService.getCodeSummary({
      pid: res.pid,
      code: res.code,
    })) as CodeVo;
    const parseQueryUrl = ['pid', 'tid', 'gid'].reduce((acc, key) => {
      const combineKey = `&`;
      if (res[key as keyof typeof res]) {
        acc += `${combineKey}${key}=${res[key as keyof typeof res]}`;
      }
      return acc;
    }, '');
    let url = `${PAGE_BASE}/${zoneService.zone}/oj/problem/detail?tab=3${parseQueryUrl}`;
    if (submitId) {
      url += `&submitId=${submitId}`;
    } else if (codeId) {
      url += `&codeId=${codeId}`;
    }
    props.sendCode({ title: res.title, url });
  } catch (error) {
    imService.messageApi.error('发送代码失败');
  }
};
</script>

<template>
  <ActionBtn
    v-track:oj_click_im_window_code.click
    :icon="icon"
    text="发代码"
    :disabled="props.disabled"
    @click="getUserCode"
  />
</template>
